import { Injectable, SkipSelf } from '@angular/core';
import { Environment, EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { LoginRequestVM } from 'src/app/viewModels/login/login-request-vm';
import { ApiEndPoints } from '../../common/apiUrls/api-end-points';
import { TokenValidateRequestVM } from 'src/app/viewModels/login/token-validate-request-vm';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl:any;
  private manageUrl:any;
 // private constant:any;
  constructor(@SkipSelf()private _http: HttpClient, private apiAddress: ApiEndPoints,
    public env: EnvService, private constant: Constants) { 
      //private constantsStaging:ConstantsStaging,private ConstantsProd:ConstantsProd
      
      //this.constant=this.constantsStaging;
      // if(this.env.env==Environment.Local)
      // {
      //   this.constant=this.constants;
      // }
      // else if(this.env.env==Environment.Staging)
      // {
      //   this.constant=this.constantsStaging;
      // }
      // else if(this.env.env==Environment.Prod)
      // {
      //   this.constant=this.ConstantsProd;
      // }
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrl = this.constant.AuthPortNumber;
 else
      this.baseUrl = this.env.apiUrl+this.constant.AuthPortNumber;

      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.manageUrl = this.constant.ManageUserPortNumber;
 else
      this.manageUrl = this.env.apiUrl+this.constant.ManageUserPortNumber;     

    }
  
    //private baseUrl =this.constant.AuthPortNumber;
    //private baseUrl = this.env.apiUrl+this.constant.AuthPortNumber;
   // private manageUrl = this.env.apiUrl+this.constant.ManageUserPortNumber;
   // private manageUrl = this.constant.ManageUserPortNumber;
    //private baseUrl = this.env.apiUrl;

  //Summary
  //LoginForm will be send as request parameters.
  //Encrytpion with AES256 has been applied for un/pass.
  login(loginReqModel: LoginRequestVM){
    const apiCallingURl = this.baseUrl + this.apiAddress.loginApiUrl;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  HandleLogin(loginReqModel: any){
    const apiCallingURl = this.manageUrl + this.apiAddress.HandleLogin;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  MatchOTP(loginReqModel: any){
    const apiCallingURl = this.manageUrl + this.apiAddress.MatchOTP;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  VerifyNewIp(loginReqModel: any){
    const apiCallingURl = this.manageUrl + this.apiAddress.VerifyNewIp;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  CheckLoginTokenEXpiry(loginReqModel: any){
    const apiCallingURl = this.manageUrl + this.apiAddress.CheckLoginTokenEXpiry;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  VerifyEmail(email,token): Observable<any> {
    const queryParam = '?Email='+email + '&Token='+token;
    const apiURL = this.manageUrl + this.apiAddress.VerifyEmail + '' + queryParam;
    return this._http.get(apiURL).pipe();     
  }

  //Summary
  //tokenValidationReqVM will be send as request parameters.
  //Will return the token for authentication purposes.
  validateToken(validateTokenReqModel: any){
    const apiCallingURl = this.baseUrl + this.apiAddress.validateUser;
    return this._http.post(apiCallingURl, validateTokenReqModel).pipe();
  }

  ValidateUserInvite(reqModel): Observable<any> {
    const apiURL = this.manageUrl + this.apiAddress.ValidateUserInvite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UserRegisterationInvite(reqModel): Observable<any> {
    const apiURL = this.manageUrl + this.apiAddress.UserRegistrationInvite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  userLogin(reqModel): Observable<any> {
    const apiCallingURl = this.baseUrl + this.apiAddress.userLogin;
    return this._http.post(apiCallingURl, reqModel).pipe();
  }
}
